// Monaco Editor environment setup for Vite/Electron
// This configures Monaco to load workers from the bundled files
// and sets up the @monaco-editor/react loader to use local Monaco

import * as monaco from 'monaco-editor';
import { loader } from '@monaco-editor/react';

// Import workers using Vite's worker import syntax
import editorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import jsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';
import cssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker';
import htmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker';
import tsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';

// Configure Monaco environment for workers BEFORE any editor is created
// This must run before monaco-editor is used
self.MonacoEnvironment = {
  getWorker(_: unknown, label: string) {
    if (label === 'json') {
      return new jsonWorker();
    }
    if (label === 'css' || label === 'scss' || label === 'less') {
      return new cssWorker();
    }
    if (label === 'html' || label === 'handlebars' || label === 'razor') {
      return new htmlWorker();
    }
    if (label === 'typescript' || label === 'javascript') {
      return new tsWorker();
    }
    return new editorWorker();
  },
};

// Configure @monaco-editor/react to use our local Monaco instance
// This prevents it from loading Monaco from CDN
loader.config({ monaco });

// Initialize the loader immediately
loader.init().then((monacoInstance) => {
  console.log('[Monaco] Initialized with local instance');
}).catch((error) => {
  console.error('[Monaco] Failed to initialize:', error);
});

export { monaco };
